export default __webpack_public_path__ + "static/media/jpy-flag.582e8c78.svg";